import ProtectedPayrollDetail from './ProtectedPayrollDetail';

export default ProtectedPayrollDetail;
